import { abyssColors } from '@/theme/colors';
import { Box, styled as muiStyled } from '@mui/material';

export const tabStyles = {
  width: 'fit-content',
  minHeight: 'fit-content',
  '& .MuiTabs-flexContainer': {
    gap: '1.6rem',
    width: 'fit-content',
  },
  '& .MuiTab-root': {
    padding: '1.2rem 1.2rem',
    fontSize: '1.4rem',
    fontStyle: 'normal',
    letterSpacing: '0',
    fontWeight: 400,
    minWidth: 'fit-content',
    minHeight: 'fit-content',
    textTransform: 'none',
  },
  '& .Mui-selected': {
    color: `${abyssColors.primary[500]} !important`,
    fontWeight: '700 !important',
  },
  '& .MuiTab-textColorPrimary': {
    color: abyssColors.primary[300],
  },
  '& .MuiTabs-indicator': {
    backgroundColor: abyssColors.primary[500],
    height: '0.4rem',
    borderRadius: '0.4rem',
    zIndex: 2,
  },
};

export const FloatingLine = muiStyled(Box)(() => ({
  borderTop: '0.1rem solid #D9D9D9',
  width: '100%',
  position: 'relative',
  bottom: '0.2rem',
  zIndex: '1',
}));
